"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PauseQueueRequestStruct = void 0;
const superstruct_1 = require("superstruct");
exports.PauseQueueRequestStruct = (0, superstruct_1.type)({
    placeId: (0, superstruct_1.string)(),
    queueId: (0, superstruct_1.string)(),
    paused: (0, superstruct_1.boolean)(),
    counterId: (0, superstruct_1.optional)((0, superstruct_1.string)()),
});
//# sourceMappingURL=PauseQueueRequest.js.map